module.exports = __webpack_public_path__ + "img/performance-1.b6b848f4.png";